import coreModule from 'app/core/core_module';
import locationUtil from 'app/core/utils/location_util';
import experimentImpressionSrv from 'app/core/services/experiments_impression_srv';
import impressionSrv from 'app/core/services/impression_srv';

let experimentRedirect = ($routeParams, $location, backendSrv, alertSrv) => {
  if ($routeParams.experimentId || $routeParams.type === 'snapshot') {
    return false;
  }

  console.log('Warning!! No experiment id found.', $location.url());

  var impressions = experimentImpressionSrv.getExperimentOpened();
  let experimentId;

  if (impressions.length > 0) {
    experimentId = impressions[0];
    let newUrl = `/e/${experimentId}${$location.path()}`;
    $location.path(newUrl).replace();
  } else {
    backendSrv.searchExperiments({ limit: 1 }).then(response => {
      if (response.results.length > 0) {
        let experimentId = response.results[0].id;
        let newUrl = `/e/${experimentId}${$location.path()}`;
        $location.path(newUrl).replace();
      } else {
        alertSrv.set('No experiment found!', 'Please upload an experiment first.', 'error', 10000);
      }
    });
  }

  return true;
};

export class LoadDashboardCtrl {
  /** @ngInject */
  constructor($scope, $routeParams, dashboardLoaderSrv, private backendSrv, $location, $injector) {
    $scope.appEvent('dashboard-fetch-start');

    if ($location.path().indexOf('/d/latest') !== -1) {
      let dashes = impressionSrv.getDashboardOpened();
      if (dashes.length > 0) {
        let dashId = dashes[0];

        backendSrv.search({ dashboardIds: [dashId] }).then(results => {
          if (results.length > 0) {
            let url = results[0].url;
            let newPath = $location.path().replace('/d/latest', url);
            $location.path(newPath).replace();
          }
        });

        return;
      }
    }

    if (!$routeParams.uid && !$routeParams.slug) {
      backendSrv.get('/api/dashboards/home').then(function(homeDash) {
        if (homeDash.redirectUri) {
          $location.path(homeDash.redirectUri);
        } else {
          var meta = homeDash.meta;
          meta.canSave = meta.canShare = meta.canStar = false;
          $scope.initDashboard(homeDash, $scope);
        }
      });
      return;
    }

    let redirected = $injector.invoke(experimentRedirect);
    if (redirected) {
      return;
    }

    // if no uid, redirect to new route based on slug
    if (!($routeParams.type === 'script' || $routeParams.type === 'snapshot') && !$routeParams.uid) {
      backendSrv.getDashboardBySlug($routeParams.slug).then(res => {
        if (res) {
          $location.path(locationUtil.stripBaseFromUrl(res.meta.url)).replace();
        }
      });
      return;
    }

    dashboardLoaderSrv.loadDashboard($routeParams.type, $routeParams.slug, $routeParams.uid).then(result => {
      if (result.meta.dashboardNotFound) {
        this.backendSrv.search().then(results => {
          let dashboards = results.filter(res => res.type === 'dash-db');
          if (dashboards.length === 0) {
            alert('Please create a dashboard first.');
          } else {
            $location.path(dashboards[0]['url']).replace();
          }
        });
      }

      // This prevents the wrong response from being processed if the dashboard
      // loader is called twice in close succession.
      if (result.meta.isSnapshot) {
        if (result.meta.snapshotKey !== $routeParams.slug) {
          return;
        }
      } else {
        if (result.dashboard.uid !== $routeParams.uid) {
          return;
        }
      }

      if (result.meta.url) {
        const url = locationUtil.stripBaseFromUrl(result.meta.url);

        // Adjusted this below to allow for experiment path suffix (/e/123)
        if ($location.path().indexOf(url) === -1) {
          $location.path(url).replace();
        }
      }

      if ($routeParams.keepRows) {
        result.meta.keepRows = true;
      }
      $scope.initDashboard(result, $scope);
    });
  }
}

export class NewDashboardCtrl {
  /** @ngInject */
  constructor($scope, $routeParams, contextSrv, $injector) {
    let redirected = $injector.invoke(experimentRedirect);
    if (redirected) {
      return;
    }

    let launcherEvents = {
      list: [
        {
          datasource: '-- Platform Influxdb --',
          enable: true,
          hide: false,
          iconColor: 'rgba(255, 96, 96, 1)',
          limit: 100,
          name: 'ECU Events',
          query: 'select * from experiment[[experiment_id]]events WHERE $timeFilter LIMIT 100',
          showIn: 0,
          tags: [],
          tagsColumn: 'key',
          type: 'tags',
        },
      ],
    };

    let dash = {
      meta: {
        canStar: false,
        canShare: false,
        isNew: true,
        folderId: Number($routeParams.folderId),
      },
      dashboard: {
        title: 'New dashboard',
        panels: [
          {
            content:
              '<h2>Welcome to your new dashboard!</h2><br>' +
              '<i><ul>' +
              '<li>Use the left-hand side bar to add panels to this dashboard.</li>' +
              '<li>Expand the experiments, pick a sensor and drag it onto this dashboard.</li>' +
              '<li>Click the settings button on the top right of the window to name your dashboard.</li>' +
              '<li>Click the arrow on the top of this panel to remove it.</li>' +
              '</ul></i>',
            editable: true,
            id: 1,
            links: [],
            mode: 'html',
            style: {},
            title: '',
            type: 'text',
            gridPos: {
              w: 12,
              h: 6,
              x: 0,
              y: 0,
            },
          },
        ],
      },
    };

    if (contextSrv.user.orgName === 'Launcher' || contextSrv.user.orgName === 'SSC E2 Org') {
      dash.dashboard['annotations'] = launcherEvents;
    }

    $scope.initDashboard(dash, $scope);
  }
}

coreModule.controller('LoadDashboardCtrl', LoadDashboardCtrl);
coreModule.controller('NewDashboardCtrl', NewDashboardCtrl);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./public/app/routes/dashboard_loaders.ts